import { Spin } from "antd";
import React from "react";

const Loading: React.FC = () => (
  <div className="flex justify-center p-16">
    <Spin size="large" />
  </div>
);

export default Loading;
